import { Paper } from "@mui/material";

import {
  getEnergyEfficiencyClassesTimelineChartOption,
  useGetEnergyEfficiencyClassesTimelineData,
} from "../../functions/Modernization";
import { DynamicEchartsChart } from "../chart/DynamicChartMemoized";

export const EnergyEfficiencyChartWithEchart = ({ chartHeight = 350, className, title }) => {
  const { dataForChart, energyClasses, labels, maxConsumption, thresholds } =
    useGetEnergyEfficiencyClassesTimelineData();

  const option = getEnergyEfficiencyClassesTimelineChartOption(
    dataForChart,
    energyClasses,
    labels,
    maxConsumption,
    thresholds
  );

  return (
    <Paper className={`relative  ${className}`}>
      <section className="flex flex-col gap-4">
        <div className="w-full">
          {title && <h3 className="font-ds-headline-md text-center">{title}</h3>}
          <div className="w-full" style={{ height: chartHeight }}>
            <DynamicEchartsChart option={option} />
          </div>
        </div>
      </section>
    </Paper>
  );
};
